module.exports = "textarea {\n    resize: none;\n}\n\n.btn.kmHistoryOption {\n    margin-top: 22px;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/kmHistory/kmHistory.editor.component.css
 ** module id = 1066
 ** module chunks = 0
 **/